$(function () {
  const header = document.querySelector('.header');
  const button = header && header.querySelector('.menu-icon');
  const menu = header && header.querySelector('.top-bar');

  if (!button || !menu) return;

  // Match the existing desktop navigation breakpoint in _header.scss.
  const desktop = window.matchMedia('(min-width: 1080px)');
  let lockedByMenu = false;

  const setOpen = (open) => {
    button.classList.toggle('is-active', open);
    menu.classList.toggle('is-active', open);
    button.setAttribute('aria-expanded', String(open));

    if (open) {
      document.body.style.setProperty(
        '--header-height',
        `${header.offsetHeight}px`
      );
      header.classList.remove('is-hidden');
      document.body.classList.remove('header--hidden');
      if (!document.body.classList.contains('blocked')) {
        document.body.classList.add('blocked');
        lockedByMenu = true;
      }
    } else if (lockedByMenu) {
      document.body.classList.remove('blocked');
      lockedByMenu = false;
    }
  };

  if (menu.id) button.setAttribute('aria-controls', menu.id);
  setOpen(false);

  button.addEventListener('click', () => {
    if (!desktop.matches) {
      setOpen(!button.classList.contains('is-active'));
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && button.classList.contains('is-active')) {
      setOpen(false);
      button.focus();
    }
  });

  menu.addEventListener('click', (event) => {
    const link = event.target.closest('a[href]');
    const href = link && link.getAttribute('href');
    if (href && !href.startsWith('#')) setOpen(false);
  });

  const resetAtDesktop = () => {
    if (desktop.matches) setOpen(false);
  };
  if (desktop.addEventListener) {
    desktop.addEventListener('change', resetAtDesktop);
  } else {
    desktop.addListener(resetAtDesktop);
  }
});
